import marigoldLogo from "./marigold.png";
import home from "./home.png";
import marigoldCircle from "./mari_logo.png";
import marigoldText from "./mari_text.png";
import rightArrow from "./right_arrow.png";
import liveSale from "./livesale.png";
import customer from "./customer.png";
import requestProduct from "./request.png";
import saleOrder from "./sale_order.png";
import changePassword from "./user_info.png";
import menu from "./menu.png";
import noti from "./noti.png";
import search from "./search.png";
import warehouse from "./warehouse.png";
import liveSaleIcon from "./live_sale_icon.png";
import product from "./product.png";
import customerIcon from "./customer_icon.png";
import calendar from "./calendar.png";
import clock from "./clock.png";
import back from "./back.png";
import bin from "./bin.png";
import defaultImage from "./default_image.png";
import deleteIcon from './delete.png'
import saleIcon from './sale_icon.png'
import user from './user.png'
import addUser from "./add_user.png";
import down from './down.png'
import cart from './cart.png'

export default {
  marigoldLogo,
  home,
  marigoldCircle,
  marigoldText,
  rightArrow,
  liveSale,
  customer,
  requestProduct,
  saleOrder,
  changePassword,
  menu,
  noti,
  search,
  warehouse,
  product,
  liveSaleIcon,
  customerIcon,
  calendar,
  clock,
  back,
  bin,
  defaultImage,
  deleteIcon,
  saleIcon,
  user,
  addUser,
  down,
  cart
};
